import { Box, Typography } from '@mui/material';

export const EmptyState = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
        flexDirection: 'column',
        textAlign: 'center',
        color: 'gx.textSecondary'
      }}
    >
      <Typography variant='body1'>We're unable to display this data at the moment.</Typography>
      <Typography variant='body1'>
        If you need access to this information, please contact GX Support.
      </Typography>
    </Box>
  );
};
